import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { omit } from 'lodash';
import { type FC, useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';
import { sendEventFillFormField, SendEventWrapper } from 'shared/lib/sendGAEvents';
import { useUpdateStateBySelector } from 'shared/lib/useUpdateStateBySelector';

import { type TWorkplaceFormFields, WorkplaceFormValidationSchema } from 'src/client/entities/creditForm';

import { formDataSelector } from 'features/UpdateWorkplaceInfo/lib/formDataSelector';
import { submitWorkplaceForm } from 'features/UpdateWorkplaceInfo/lib/submitWorkplaceForm';

import { FormFieldsControls } from '../../WorkplaceInfo.config';
import { WorkplaceInfoTexts } from '../../WorkplaceInfo.texts';
import { WorkplaceInfoViewHoc } from '../FormBody/FormBody';

export const Form: FC<
  IFormPopup & {
    shouldRestoreAdditionalData?: boolean;
  }
> = ({
  isLoading,
  isDialog = false,
  onClose,
  setHeader,
  isFormForceOpened,
  onFormSubmit,
  shouldRestoreAdditionalData,
  stepIndex,
  formId,
  submitButtonText = 'Далее',
  isAnyFormStepOpenedInPopup,
  analyticsOverrides,
}) => {
  const dispatch = useAppDispatch();
  const [formData] = useUpdateStateBySelector(formDataSelector);

  const handleData = async (actualData: TWorkplaceFormFields, type: string) => {
    // убираем лишние поля, которые нужны только для валидации
    const data = omit(actualData, ['mobilePhone', 'additionalPhone']) as TWorkplaceFormFields;
    if (type === 'fullFilled') {
      dispatch(submitWorkplaceForm(data, analyticsOverrides));
      onFormSubmit?.(data, isDialog);
    }
    if (isDialog) {
      onClose?.(true);
    }
  };

  const sendAnalyticsEvent = useCallback(
    ({ fieldName }: IAnalyticsEventFormField) => {
      sendEventFillFormField(
        stepIndex + 1,
        WorkplaceInfoTexts[fieldName as keyof TWorkplaceFormFields],
        true,
        analyticsOverrides,
      );
    },
    [stepIndex, analyticsOverrides],
  );

  return (
    <SendEventWrapper sendEvent={sendAnalyticsEvent}>
      <WorkplaceInfoViewHoc
        isDialog={isDialog}
        onDataChanged={handleData}
        defaultData={formData}
        validationSchema={WorkplaceFormValidationSchema()}
        isLoading={isLoading}
        additionalProps={{
          setHeader,
          isFormForceOpened,
          shouldRestoreAdditionalData: !!shouldRestoreAdditionalData,
          formId,
          isAnyFormStepOpenedInPopup,
          analyticsOverrides,
        }}
        formLabels={WorkplaceInfoTexts}
        formFieldsControls={FormFieldsControls}
        submitButtonText={submitButtonText}
      />
    </SendEventWrapper>
  );
};
